import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  loading: true,
  pictureOfTheDay: [],
  spaceStationInformation: {}
};

const fetchPictureOfTheDayStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchPictureOfTheDay = (state, action) => {
  return updateObject(state, {
    pictureOfTheDay: action.pictureOfTheDay
  });
};

const fetchPictureOfTheDaySuccess = (state, action) => {
  return updateObject(state, {
    pictureOfTheDay: action.pictureOfTheDay,
    loading: false
  });
};

const fetchSpaceStationStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchSpaceStation = (state, action) => {
  return updateObject(state, {
    spaceStationInformation: action.spaceStationInformation
  });
};

const fetchSpaceStationSuccess = (state, action) => {
  return updateObject(state, {
    spaceStationInformation: action.spaceStationInformation,
    loading: false
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PICTURE_OF_THE_DAY_START:
      return fetchPictureOfTheDayStart(state, action);
    case actionTypes.FETCH_PICTURE_OF_THE_DAY:
      return fetchPictureOfTheDay(state, action);
    case actionTypes.FETCH_PICTURE_OF_THE_DAY_SUCCESS:
      return fetchPictureOfTheDaySuccess(state, action);

    case actionTypes.FETCH_SPACE_STATION_START:
      return fetchSpaceStationStart(state, action);
    case actionTypes.FETCH_SPACE_STATION:
      return fetchSpaceStation(state, action);
    case actionTypes.FETCH_SPACE_STATION_SUCCESS:
      return fetchSpaceStationSuccess(state, action);

    default:
      return state;
  }
};

export default reducer;
